import styled from 'styled-components';

import { useImageLoader } from 'hooks/UseImageLoader';
import { JRCLoader } from 'components/JRCLoader/JRCLoader';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import React from 'react';
import { JRCWidgetImage } from 'components/Widgets/JRCWidgetImage/JRCWidgetImage';
import { WidgetSliderSlide } from '../types';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';
import { JRCFlexBox } from 'components/JRCFlex/JRCFlexBox';
import { useIntl } from 'react-intl';

const CSSImageLoaderPlaceholder = styled.div<{ width: number; height: number }>`
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    max-width: ${(props) => props.width}px;
    max-height: ${(props) => props.height}px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CSSSliderImageWrapper = styled.div`
    width: 100%;
    cursor: pointer;
`;

export const SliderImage = ({
    initialUri,
    maxWidth = 800,
    maxHeight,
    onClick,
}: {
    initialUri: string;
    maxWidth: number;
    maxHeight: number;
    onClick?: () => void;
} & Pick<WidgetSliderSlide, 'displayAs' | 'backgroundSize' | 'backgroundPosition'>) => {
    const intl = useIntl();
    const { loading, error } = useImageLoader(
        initialUri.length ? initialUri : '/img/applications/articleWidgets/widget-article-image-placeholder.png',
        maxWidth,
    );

    if (initialUri === undefined || !initialUri.length) {
        return (
            <CSSImageLoaderPlaceholder width={maxWidth} height={maxHeight}>
                <JRCFlexBox direction="column" x="center">
                    <img src={'/img/applications/articleWidgets/widget-article-image-placeholder.png'} width={80} />
                    <Typography>{intl.formatMessage({ id: 'SLIDER_IMAGE_Empty_Des' })}</Typography>
                </JRCFlexBox>
            </CSSImageLoaderPlaceholder>
        );
    }

    if (error && !initialUri.length) {
        return (
            <CSSImageLoaderPlaceholder width={maxWidth} height={maxHeight}>
                <JRCIcon name="icon-warning" color={'orange'} size={80} />
            </CSSImageLoaderPlaceholder>
        );
    }

    if (loading) {
        return (
            <CSSImageLoaderPlaceholder width={maxWidth} height={maxHeight}>
                <JRCLoader size={'l'} />
            </CSSImageLoaderPlaceholder>
        );
    }

    return (
        <CSSSliderImageWrapper onClick={onClick}>
            <JRCWidgetImage uri={initialUri} maxWidth={maxWidth} maxHeight={maxWidth / (16 / 9)} />
        </CSSSliderImageWrapper>
    );
};
